<template>
  <button v-if="isUserLoggedIn" @click="profile" class="d-flex align-center justify-end px-2">
    <img :src="userdata.image" alt="" v-if="userdata.image" class="companyimage">
    <v-icon icon="mdi-account" v-else></v-icon>
    <div>
      <p class="px-1 font-weight-bold text-right">
      {{ $t("Profile") }}
    </p>
    <h5 class="text-center">
      {{ userdata.name }}
    </h5>
    </div>
    
  </button>
  <button class="px-2 d-flex align-center " @click="resigt" v-else>
    <v-icon icon="mdi-account-outline"></v-icon>
    <p>
    {{ $t("LogIn") }}
    </p>
  </button>
</template>
<script>
import { ref } from "vue";
import { useAuth } from "../../axios";
import crudDataService from "@/Services/crudDataService";
export default {
  data(){
    return{
      logined:"",
      userdata:''
    }
  },
  setup() {
    const { isLoggedIn } = useAuth();
    const isUserLoggedIn = ref(isLoggedIn());
    return {
      isUserLoggedIn,
    };
  },
  components: {},
  methods: {
    async userprofile() {
      const id = localStorage.getItem("userId");
      if (id) {
      let response = await crudDataService.get(`user-profile`, id);
      this.userdata=response.data.data
      console.log(this.userdata);
      }
    },
    resigt() {
      this.$router.push({ name: "LogIn" });
    },
    profile() {
      this.$router.push({ name: "Profile" });
    },
  },
  mounted() {
    this.userprofile()
    // this.logined = localStorage.getItem("authToken")?true:false
    // console.log(this.logined);
  },
};
</script>
<style lang="scss" scoped>
.companyimage{
  width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #000;
}
</style>
